/**
 * Return the value for the given parameter from the URL.
 *
 * @param name : A parameter name
 */
export function getParameterByName(name: string): string {
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
